// extracted by mini-css-extract-plugin
export var brand = "_v-9";
export var button = "_v-0";
export var chevron = "_v-v";
export var chevronButton = "_v-w";
export var content = "_v-n";
export var danger = "_v-g";
export var dangerOutlined = "_v-h";
export var dark = "_v-l";
export var darkTheme = "_v-c";
export var extraSmall = "_v-4";
export var fullWidth = "_v-8";
export var ghost = "_v-d";
export var gray = "_v-t";
export var icon = "_v-p";
export var iconButton = "_v-s";
export var iconButtonBorder = "_v-x";
export var iconButtonBorderDark = "_v-y";
export var iconButtonBorderLight = "_v-z";
export var iconLeft = "_v-q";
export var iconRight = "_v-r";
export var large = "_v-1";
export var light = "_v-m";
export var medium = "_v-2";
export var micro = "_v-5";
export var nano = "_v-7";
export var outlined = "_v-k";
export var pending = "_v-a";
export var primary = "_v-i";
export var shadow = "_v-o";
export var small = "_v-3";
export var solidLight = "_v-e";
export var solidLightBrand = "_v-f";
export var spinner = "_v-u";
export var transparent = "_v-j";
export var warning = "_v-b";
export var wideNano = "_v-6";